// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1kSmk","amount":"Amount_amount__3YuT7","tip":"Amount_tip__3twmd","tipHeader":"Amount_tipHeader__1cADF","tipsWrap":"Amount_tipsWrap__1sCNn"};